import { StyleSheet, View } from "react-native";
import { Button } from "~/components/Button";
import { HomeCard } from "~/components/layout/home/HomeCard";
import { ListingGroup } from "~/components/layout/ListingGroup";
import { ListingItem } from "~/components/layout/ListingItem";
import { Page } from "~/components/layout/Page";
import { LatestBlogs } from "~/components/layout/resources/LatestBlogs";
import { ResourceCard } from "~/components/layout/resources/ResourceCard";
import { BodyText } from "~/components/layout/text";
import { Can } from "~/components/permission/Can";
import { ToDo } from "~/components/permission/ToDo";
import { QendoIcon } from "~/components/QendoIcon";
import { QendoLogo } from "~/components/QendoLogo";
import { QENDO_LINKS } from "~/constants/environment";
import { Items } from "~/constants/layout";
import { Space } from "~/constants/sizing";
import { useProfile } from "~/providers/ProfileProvider";

const community_background = require("~/assets/qendo-community.jpg");
const mentor_background = require("~/assets/mentor-program.jpg");

export default function Resources() {
    const { cannot } = useProfile();

    return (
        <Page gradient tabs padding={0}>
            <View style={styles.body}>
                <HomeCard
                    title="Helpful resources"
                    icon="resources"
                    subtitle="Our curated educational resources are designed to inform and support you."
                />
                <ListingGroup>
                    <ToDo until="Bookmarks">
                        <ListingItem icon="bookmark" title="My bookmarks" last={cannot("view", "goals")} />
                    </ToDo>
                    <Can section="goals" ability="view">
                        <ListingItem href="/resources/goals" icon="heart" title="My goals" />
                    </Can>
                    <ListingItem href="/resources/exercise" icon="exercise" title="Exercise" />
                    <ListingItem href="/resources/nutrition" icon="food" title="Nutrition" />
                    <ListingItem href="/resources/pain" icon="pain" title="Pain" />
                    <ListingItem href="/resources/carer-support" icon="care-team" title="Carer support" last />
                </ListingGroup>
                <ListingGroup title="Video series">
                    <ListingItem
                        title="Manage Endo"
                        left={() => <QendoLogo />}
                        href="/resources/videos/manage-endo"
                        subtitle="Practical tools and insights to help you navigate endometriosis."
                        last
                    />
                </ListingGroup>
                <LatestBlogs />
                <Button title="All blog posts" href="/resources/blog" variant="secondary" size="lg" />
            </View>
            <ResourceCard title="QENDO Community" source={community_background}>
                <BodyText>
                    Our online communities are a safe and supportive space to connect, share experiences, and access
                    valuable resources.
                </BodyText>
                <ListingGroup>
                    <ListingItem icon="calendar" href="/resources/upcoming-events" title="Community events" />
                    <ListingItem icon="care-team" href="/resources/community" title="QENDO communities" last />
                </ListingGroup>
            </ResourceCard>

            <ResourceCard title="QENDO Mentor Program" source={mentor_background}>
                <BodyText>
                    Navigating life with a chronic condition can feel overwhelming, especially after a new diagnosis.
                    Our free QENDO Mentor Program is here to help.
                </BodyText>
                <View style={Items.start}>
                    <Button title="Learn more" iconRight="external-link" href={QENDO_LINKS.mentor_program} />
                </View>
                <ListingGroup>
                    <ListingItem
                        href={QENDO_LINKS.mentor_signup}
                        title="Mentor sign up"
                        right={() => <QendoIcon name="external-link" size={20} />}
                    />
                    <ListingItem
                        href={QENDO_LINKS.mentee_signup}
                        title="Mentee sign up"
                        right={() => <QendoIcon name="external-link" size={20} />}
                        last
                    />
                </ListingGroup>
            </ResourceCard>
        </Page>
    );
}

const styles = StyleSheet.create({
    body: {
        padding: Space.md,
        gap: Space.lg,
    },
});
